export default __webpack_public_path__ + "static/media/404.d79e76e3.svg";